import { IColumn } from '../models';

const getCustomSurveyQuestionColumns = () => {
	return [isSelectedColumn, textColumn, responseOptionsColumn, translationsColumn, actionsColumn];
};
const getCustomDemographicQuestionColumns = () => {
	return [isSelectedColumn, textColumn, responseOptionsColumn, mappedAttributeColumn, translationsColumn, actionsColumn];
};

export const CustomQuestionColumnHelper = {
	getCustomSurveyQuestionColumns,
	getCustomDemographicQuestionColumns,
};

const isSelectedColumn: IColumn = {
	name: 'isSelected',
	displayOrder: 1,
	displayText: 'Add Question',
	sortAscByDefault: true,
	checked: true,
	disabled: true,
};
const textColumn: IColumn = {
	name: 'text',
	displayOrder: 2,
	displayText: 'Question',
	sortAscByDefault: true,
	checked: true,
	disabled: true,
};
const responseOptionsColumn: IColumn = {
	name: 'responseOptions',
	displayOrder: 3,
	displayText: 'Response Option',
	sortAscByDefault: true,
	checked: true,
	disabled: true,
};
const mappedAttributeColumn: IColumn = {
	name: 'mappedAttribute',
	displayOrder: 4,
	displayText: 'Mapped Attribute',
	sortAscByDefault: true,
	checked: true,
	disabled: true,
};
const translationsColumn: IColumn = {
	name: 'translations',
	displayOrder: 5,
	displayText: 'All Enabled Languages',
	sortAscByDefault: true,
	checked: true,
	disabled: true,
};
const actionsColumn: IColumn = {
	name: 'actions',
	displayOrder: 6,
	displayText: 'Actions',
	sortAscByDefault: true,
	checked: true,
	disabled: true,
};
